/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { createJotaiVuexFacadeForReact } from "common/vue/createJotaiVuexFacadeForReact";
import { jotaiStore } from "./canvaModule.atoms";
import canvaModule from "./canvaModule";

type FacadeOptions = Parameters<typeof createJotaiVuexFacadeForReact>[0];
type FacadeJotaiStore = FacadeOptions["jotaiStore"];
type FacadeModuleConfig = NonNullable<FacadeOptions["modules"]>[string];

const canvaStore = createJotaiVuexFacadeForReact({
  jotaiStore: jotaiStore as unknown as FacadeJotaiStore,
  state: {},
  stateKey: "canvaState",
  modules: {
    canva: canvaModule as unknown as FacadeModuleConfig
  }
});

export default canvaStore;
